import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#F6F6F6",
            fontFamily: "Poppins, sans-serif",
            padding: "1.5rem",
          }}
        >
          <div
            style={{
              maxWidth: "28rem",
              width: "100%",
              textAlign: "center",
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem 2rem",
              boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
              border: "1px solid #eee",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                margin: "0 auto 1.25rem",
                borderRadius: "9999px",
                backgroundColor: "#DEC2AA",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#1a1a1a",
                fontSize: "28px",
                fontWeight: 700,
              }}
            >
              !
            </div>
            <h2
              style={{
                margin: "0 0 0.5rem",
                fontSize: "1.25rem",
                fontWeight: 600,
                color: "#1a1a1a",
              }}
            >
              Something went wrong
            </h2>
            <p
              style={{
                margin: "0 0 1.5rem",
                fontSize: "0.9rem",
                color: "#666",
                lineHeight: 1.6,
              }}
            >
              The page hit an unexpected error. Reloading usually fixes it.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                backgroundColor: "#1a1a1a",
                color: "#ffffff",
                border: "none",
                borderRadius: "10px",
                padding: "0.75rem 1.75rem",
                fontSize: "0.9rem",
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
